import useQueueHandler from "./useQueueHandler";

// EndPoints
export const apiGetAccountInfo     = 'get-account-info';   // app
export const apiGetTeamInfo        = 'get-team-info';      // app

// const apiSaveUserField      = 'save-user-field';    // app

// const apiTellUser           = 'tell-user';          // app, dispatch To Target User via q/ private-chat
// const apiInvite             = 'invite';             // app
//?? const apiInvitesInfo        = 'invites-info'; // ??

// Topic Listeners
//const topicTeamUpdated      = 'team-updated';     // Not implemented yet on the server (update team)
//const topicAccountUpdated   = 'account-updated';  // Not implemented yet on the server (update account)

// My Queue Listeners
const qMyAccountInfo        = 'my-account-info';
const qMyTeamInfo           = 'my-team-info';
const qMyProfileUpdated     = 'my-profile-updated';


export default function useOrganListener() {  
  
  const {queueData:myAccountData}    = useQueueHandler(qMyAccountInfo);
  const {queueData:myTeamData}       = useQueueHandler(qMyTeamInfo);
  const {queueData:myProfileUpdated} = useQueueHandler(qMyProfileUpdated);
  const {queueData:myInvites}        = useQueueHandler('invites-info');

  // Queue

  return {
    myAccountData,
    myTeamData,
    myProfileUpdated,
    myInvites
  }
}
